import { IRoleCrudModalLang } from '../../../types/lang'

export const roleCrudModalLang: IRoleCrudModalLang = {
	role_crud_modal: {
		title_create: 'Create role_ua',
		title_edit: 'Edit role_ua',
		title_clone: 'Clone role from base role_ua',
		title_remove_single: 'Remove <span>role_ua</span>',
		title_remove_multiple: 'Remove <span>roles_ua</span>',
		title_remove_multiple_cnt: 'Remove <span>{{cnt}} selected role(s)_ua</span>',
		title_not_remove_multiple_cnt: 'Will NOT be removed <span>{{cnt}} selected role(s) (SYSTEM)_ua</span>',
		field_code_label: 'Code_ua',
		field_code_placeholder: 'Code_ua',
		field_name_label: 'Name_ua',
		field_name_placeholder: 'Name_ua',
		field_is_system_label: 'System_ua',
		field_is_buyer_label: 'Buyer_ua',
		field_in_group_label: 'In group_ua',
		field_in_group_placeholder: 'In group_ua',
		field_is_team_label: 'Is team_ua',
		field_is_team_placeholder: 'Is team_ua',
		field_team_report_label: 'Team Report_ua',
		field_team_report_placeholder: 'Team Report_ua',
		field_notes_label: 'Notes_ua',
		field_notes_placeholder: 'Notes_ua',
		msg_remove_confirm: 'Are you sure?_ua',
		btn_create: 'Create_ua',
		btn_update: 'Save_ua',
		btn_clone: 'Clone_ua',
		btn_remove: 'Remove_ua',
		btn_close: 'Close_ua'
	}
}